import { render, staticRenderFns } from "./bin.vue?vue&type=template&id=050bbd85&"
import script from "./bin.vue?vue&type=script&lang=js&"
export * from "./bin.vue?vue&type=script&lang=js&"
import style0 from "./bin.vue?vue&type=style&index=0&id=050bbd85&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports